<template>
  <div class="tw-flex tw-justify-center tw-h-screen">
    <div class="tw-flex tw-items-center">
      <sign-in-card class="tw-w-full" :initialEmail="email" :buttonLocation="'body'" :showFooter="false" :showForgotPassword="true" @success="success" />
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import SignInCard from "@/components/SignInCard";

export default {
  components: {
    SignInCard,
  },
  data() {
    return {
      isLoading: false,
      email: null,
      password: null,
    };
  },
  created() {
    this.email = this.$route.query.e;
  },
  methods: {
    ...mapActions("organization", { orgInit: "init" }),
    ...mapActions("role", { roleInit: "init" }),
    success() {
      this.orgInit();
      this.roleInit();
      this.$emit("signIn");
    },
  },
};
</script>
